module.exports = __webpack_public_path__ + "img/pencil-edit.cfc04fbd.svg";